import React from "react";
import Tooltip from "./Tooltip";
import "../styles/Tooltip.scss";

const ToolTipAndLink = ({ value, children }) => {
  const tooltipContent = typeof value === "string" ? value : "";

  return (
    <Tooltip content={tooltipContent} position="top">
      <span className="tooltip-trigger-text">{children || tooltipContent}</span>
    </Tooltip>
  );
};

export default ToolTipAndLink;
